import styled from 'styled-components';

export const Instructions = styled.div`
  font-size: 0.75em;
  color: ${({ theme }) => theme.colors.gray};
  margin-top: 0.125rem;
  margin-left: 0.25rem;
`;
